// 🔧 BASE URL CON /API
//const baseUrl = process.env.REACT_APP_API_BASE_URL || '/api';
const baseUrl = process.env.REACT_APP_API_BASE_URL || '/api'

export async function apiFetch(url, options = {}) {
  // 🔧 ASSICURATI CHE L'URL NON INIZI CON /API
  let cleanUrl = url;
  if (cleanUrl.startsWith('/api')) {
    cleanUrl = cleanUrl.substring(4); // Rimuove '/api'
  }
  
  // Assicurati che inizi con /
  if (!cleanUrl.startsWith('/')) {
    cleanUrl = '/' + cleanUrl;
  }
  
  // 🔧 TIMEOUT CONFIGURABILE
  const timeout = options.timeout || 300000;
  
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    console.warn(`⏰ Timeout raggiunto per ${baseUrl}${cleanUrl} dopo ${timeout/1000}s`);
    controller.abort();
  }, timeout);

  const token = localStorage.getItem('token');

  try {
    const headers = {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };

    if (!(options.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    // 🔧 DEBUG: Log della richiesta
    console.log(`🔄 API Request: ${baseUrl}${cleanUrl}`, { method: options.method || 'GET' });

    const response = await fetch(baseUrl + cleanUrl, {
      ...options,
      signal: controller.signal,
      headers: headers,
    });
    
    clearTimeout(timeoutId);
    
    console.log(`✅ API Response: ${response.status} ${response.statusText} for ${baseUrl}${cleanUrl}`);
    
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    console.error(`❌ API Error for ${baseUrl}${cleanUrl}:`, error);
    
    if (error.name === 'AbortError') {
      throw new Error(`Timeout: richiesta interrotta dopo ${timeout/1000} secondi`);
    }
    
    throw error;
  }
}